import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {InBaseFrwComponent} from '../../inBaseFrwComponent';

@Component({
  selector: 'cmp-modal-body',
  template: `<div class="modal-body" [ngStyle]="customHeight ? {'overflow-y': 'auto', 'height': customHeight} : ''">
  <ng-content></ng-content>
</div>
`,
  styles: [`.modal-body{overflow-y:auto}`]
})
export class ModalBodyComponent extends InBaseFrwComponent {

  @Input() customHeight;

  constructor() {
    super();
  }
}
